<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>{{fromAgreementListPage ? 'Boleto' : 'Pagamento acordo'}}</h1>
    </div>

    <app-informacoes-cartao [nomeProduto]="nomeProduto"  [customerName]="nomeTitular" [numeroCartaoMascarado]="numeroCartaoMascarado"></app-informacoes-cartao>

    <div class="checkout-container">
      <div class="header">
        <img src="/assets/images/icons/ic-checkout-boleto.svg" width="24px" height="24px" alt="checkout boleto">
        <h2> Boleto </h2>
        <strong *ngIf="(isMobileMatches | async).matches">{{(parcelaSelecionada?.nrParcela === 1 ? acordoVigente?.valorEntrada : acordoVigente?.valorParcela) | currencyMask }}</strong>
      </div>

      <div class="payment-container">
        <div class="payment-info-container">
          <div class="bar-code-container">
            <span *ngIf="parcelaSelecionada?.linhaDigitavel" class="code">{{parcelaSelecionada.linhaDigitavel}}</span>
          </div>

          <button type="button" (click)="copyBarCodeToClipboard()" class="copy-code-btn" mat-flat-button color="primary">
            <mat-icon>content_copy</mat-icon>
            <span>
              Copiar linha digitável
            </span>
          </button>

          <hr *ngIf="(isMobileMatches | async).matches"  class="payment-resume-mobile-divider" />

          <div class="send-actions" *ngIf="!(isMobileMatches | async).matches">
            <button type="button" (click)="downloadInvoice()" mat-stroked-button class="outlined" color="primary">
              <span>
                Download do boleto
              </span>
              </button>
              <button *ngIf="!hideShareActions" [disabled]="!userProfile?.email" type="button" (click)="sendInvoicePaymentCode()" [disabled]="disabledEmail" mat-stroked-button class="outlined" color="primary">
                <span>
                  Enviar por e-mail
                </span>
              </button>
            </div>

          <ul class="payment-instructions">
            <li class="instruction">
                Copie o código do boleto acima;
            </li>
            <li class="instruction">
                Acesse o site ou o app do seu banco para seguir com o pagamento;
            </li>
            <li class="instruction">
                Você também pode pagar em lotéricas.
            </li>
          </ul>
          <hr *ngIf="(isMobileMatches | async).matches"  class="payment-resume-mobile-divider" />

          <div class="send-actions" *ngIf="(isMobileMatches | async).matches">
            <button type="button" *ngIf="!hideShareActions" mat-flat-button color="primary" (click)="sendInvoicePaymentCode()" [disabled]="disabledEmail">
              <span>
                Enviar por e-mail
              </span>
            </button>
            <button type="button" (click)="downloadInvoice()" mat-stroked-button class="outlined" color="primary">
              <span>
                Download do boleto
              </span>
            </button>
          </div>

          <hr *ngIf="(isMobileMatches | async).matches"  class="payment-resume-mobile-divider" />
        </div>

        <div class="payment-resume-info">
          <div class="resume">
            <div class="resume-item">
              <span *ngIf="parcelaSelecionada?.dataVencParcela">
                {{parcelaSelecionada?.nrParcela > 1 ? 'Vencimento do boleto' : 'Previsão de Vencimento'}}
              </span> 
              <strong>{{parcelaSelecionada?.dataVencParcela | date:'dd/MM/yyyy'}}</strong>
            </div>
            <hr *ngIf="fromAgreementListPage && !acordoAvista && (parcelaSelecionada?.nrParcela > 1)" />
            <div *ngIf="fromAgreementListPage && !acordoAvista && (parcelaSelecionada?.nrParcela > 1)" class="resume-item">
              <span>
                Parcela
              </span> 
              <strong *ngIf="parcelaSelecionada?.nrParcela">{{parcelaSelecionada?.nrParcela - 1}}/{{acordoVigente?.parcelas?.length -1}}</strong>
            </div>
            <hr />
              <div class="resume-item">
                <span *ngIf="acordoAvista">Valor à vista</span>
                <span *ngIf="!acordoAvista && parcelaSelecionada?.nrParcela">
                  {{parcelaSelecionada?.nrParcela !== 1 ? 'Valor da parcela' : 'Valor da entrada'}}
                </span> 
                <strong *ngIf="parcelaSelecionada?.nrParcela !== 1 ">{{acordoVigente?.valorParcela | currencyMask}}</strong>
                <strong *ngIf="parcelaSelecionada?.nrParcela === 1 ">{{acordoVigente?.valorEntrada | currencyMask}}</strong>
              </div>
            <hr />
          </div>

          <div class="payment-instructions">
            <span *ngIf="acordoVigente?.percentualMensalCET" class="instruction">
              *Custo Efetivo Total (CET) percentual: {{acordoVigente?.percentualMensalCET | number: '1.2-2'}}%  ao mês | {{acordoVigente?.percentualAnualCET| number: '1.2-2'}}% ao ano
            </span>
            <span class="instruction">
              O boleto também pode ser enviado para o e-mail cadastrado.
            </span>
            <span *ngIf="fromAgreementListPage" class="instruction">
              <strong>Importante:</strong> 
              Mantenha os pagamentos em dia e evite o cancelamento do acordo.
            </span>
            <span *ngIf="!fromAgreementListPage" class="instruction">
              <strong>Importante:</strong> 
              Caso seu pagamento não seja efetivado até a data de vencimento, este boleto será cancelado. O contrato de renegociação começa a valer somente após a confirmação do pagamento.
            </span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="(isMobileMatches | async).matches" class="installment-info">
      <div class="resume-item">
        <span *ngIf="parcelaSelecionada?.dataVencParcela">
          {{parcelaSelecionada?.nrParcela > 1 ? 'Vencimento do boleto' : 'Previsão de Vencimento'}}
        </span> 
        <strong>{{parcelaSelecionada?.dataVencParcela | date:'dd/MM/yyyy'}}</strong>
      </div>
      <hr *ngIf="fromAgreementListPage && !acordoAvista && (parcelaSelecionada?.nrParcela > 1)" />
      <div *ngIf="fromAgreementListPage && !acordoAvista && (parcelaSelecionada?.nrParcela > 1)" class="resume-item">
        <span>
          Parcela
        </span> 
        <strong *ngIf="parcelaSelecionada?.nrParcela">{{parcelaSelecionada?.nrParcela - 1}}/{{acordoVigente?.parcelas?.length - 1}}</strong>
      </div>
      <hr />
      <div class="resume-item">
        <span *ngIf="acordoAvista">Valor à vista</span>
        <span *ngIf="!acordoAvista && parcelaSelecionada?.nrParcela">
          {{parcelaSelecionada?.nrParcela !== 1 ? 'Valor da parcela' : 'Valor da entrada'}}
        </span> 
        <strong *ngIf="parcelaSelecionada?.nrParcela !== 1 ">{{acordoVigente?.valorParcela | currencyMask}}</strong>
        <strong *ngIf="parcelaSelecionada?.nrParcela === 1 ">{{acordoVigente?.valorEntrada | currencyMask}}</strong>
      </div>
    </div>

    <div class="page-actions">
      <button (click)="handleCancel()" type="button" mat-stroked-button class="outlined" color="primary">
        <span>
          Fechar
        </span>
      </button>
      <button (click)="handleGoToCurrentAgreement()" type="button" mat-flat-button color="primary">
        <span>
          {{fromAgreementListPage ? 'Voltar para acompanhamento' : 'Acompanhar acordo'}}
        </span>
      </button>
    </div>
  </div>
</section>